import React from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getBacktestByEntity } from '../services/api';
import BacktestLaunchForm from './BacktestLaunchForm';
import BacktestMatrixView from './BacktestMatrixView';

/* Section backtest pilotée par état (drill-down by-entity).
   Poll 4s tant que pending/running ; rend le formulaire / spinner / matrice / erreur.
   Réutilise les classes CSS .tdp-* (l'hôte fournit le <style>). */

export default function BacktestSection({ kind, address }) {
  const qc = useQueryClient();
  const queryKey = ['bt-entity', kind, address];

  const { data, isLoading, isError, error } = useQuery({
    queryKey,
    queryFn: () => getBacktestByEntity(kind, address),
    refetchInterval: (q) => {
      const s = q?.state?.data?.status;
      return (s === 'pending' || s === 'running') ? 4000 : false;
    },
  });

  // Après lancement : invalide pour repasser tout de suite en pending/running.
  const onLaunched = () => qc.invalidateQueries({ queryKey });

  // Encadré commun : sépare nettement la section backtest du bloc tokens en dessous.
  const card = (children) => (
    <div className="tdp-bt-card">
      <div className="tdp-bt-hd">⚙ Backtest reconstruction Helius (slot-1 × TP)</div>
      {children}
    </div>
  );

  if (isLoading) return card(<div className="tdp-empty">Chargement…</div>);
  if (isError) return card(<div className="tdp-empty">Erreur : {error?.message || 'inconnue'}</div>);

  const status = data?.status;

  if (status === 'none') {
    return card(<BacktestLaunchForm kind={kind} address={address} onLaunched={onLaunched} />);
  }
  if (status === 'pending' || status === 'running') {
    return card(
      <div className="tdp-empty">
        Backtest en cours… (statut : {status})
      </div>
    );
  }
  if (status === 'error') {
    return card(
      <div>
        <div className="tdp-empty" style={{ color: 'var(--red,#ff3b5c)' }}>
          Échec du backtest : {data?.error_msg || 'erreur inconnue'}
        </div>
        <BacktestLaunchForm kind={kind} address={address} onLaunched={onLaunched} />
      </div>
    );
  }
  if (status === 'done') {
    return card(<BacktestMatrixView result={data?.result} />);
  }
  return card(<BacktestLaunchForm kind={kind} address={address} onLaunched={onLaunched} />);
}
